<template>
  <!--  @click="$router.push(link)" -->
  <a class="a">
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: 'my-a',
  props: {
    link: {
        type: String,
        required: true,
    }
  }
}
</script>

<style scoped>
.a {
  all: unset;
  cursor: default;
  padding: 5px 10px;
  border: 2px solid teal;
  border-radius: 15px;
  background-color: transparent;
  text-decoration: none;
  /* text-decoration: all unset; */
}
.a:hover {
  /* all: unset; */
  text-decoration: none;
  /* text-decoration: all unset; */
}
</style>
